import styles from "../../styles/Components/layout/Sidebar.module.css";
import { Link, useLocation } from "react-router-dom";
import { RiHome6Line } from "react-icons/ri";
import { FiMenu, FiPieChart } from "react-icons/fi";
import { BsBarChartLineFill } from "react-icons/bs";
import { PiChartLineUp, PiRobot } from "react-icons/pi";
import { HiMiniBellAlert } from "react-icons/hi2";
import { MdOutlineCandlestickChart, MdSubscriptions } from "react-icons/md";
import { TbCloudCheck } from "react-icons/tb";
import { IoHelpBuoyOutline, IoLogOutOutline } from "react-icons/io5";
import { useMemo, useState } from "react";
import { FaRegCircleUser } from "react-icons/fa6";
import { setLogout } from "../../redux/main/action/main";
import PoolData from "../../pages/Auth/AWSConfig/PoolData";
import { useDispatch } from "react-redux";

// dashboard: <RiHome6Line /> <PiHouseLine />
// portfolio: <LuChartPie />
// assistant: <BsBarChartLineFill />
// insight: <PiChartLineUp />
// bot: <PiRobot />
// alert: <HiMiniBellAlert />
// simulator: <MdOutlineCandlestickChart />
// develop: <TbCloudCheck />
// <MdSubscriptions />
// help: <IoHelpBuoyOutline />

function SidebarItem({ name, icon, path, isActive }) {
  return (
    <li>
      <Link
        to={path}
        className={`${styles.sidebarItem} ${name === "Portfolio" ? styles.divider : ""} ${isActive ? styles.active : ""} ${name === "Trade Simulator" ? styles.comingSoon : ""} ${name === "Insights2" ? styles.preview : ""}`}
      >
        <span className={styles.sidebarIcon}>{icon}</span>
        <span className={styles.sidebarTitle}>{name}</span>
      </Link>
    </li>
  );
}

function Sidebar() {
  const { pathname } = useLocation();
  const [isCollapsed, setCollapsed] = useState(
    () => JSON.parse(localStorage.getItem("sidebar-collapsed")) || false,
  );

  const dispatch = useDispatch();

  const itemsData = useMemo(() => {
    const currentPath = pathname.split("/")?.[1];
    return [
      {
        name: "Dashboard",
        icon: <RiHome6Line />,
        path: "/dashboard",
        isActive: currentPath === "dashboard",
      },
      {
        name: "Portfolio",
        icon: <FiPieChart />,
        path: "/portfolio",
        isActive: currentPath === "portfolio",
      },
      {
        name: "AI Assistant",
        icon: <BsBarChartLineFill />,
        path: "/ai-assistant/assistant",
        isActive: currentPath === "ai-assistant",
      },
      {
        name: "AI Bot",
        icon: <PiRobot />,
        path: "/bot-automation",
        isActive: currentPath === "bot-automation",
      },
      {
        name: "Insights",
        icon: <PiChartLineUp />,
        path: "/insight",
        isActive: currentPath === "insight",
      },
      {
        name: "Alert System",
        icon: <HiMiniBellAlert />,
        path: "/alert-system",
        isActive: currentPath === "alert-system",
      },
      {
        name: "Trade Simulator",
        icon: <MdOutlineCandlestickChart />,
        path: "/trade-simulator",
        isActive: currentPath === "trade-simulator",
      },
      {
        name: "Developer API",
        icon: <TbCloudCheck />,
        path: "/developer-api",
        isActive: currentPath === "developer-api",
      },
      {
        name: "Subscription",
        icon: <MdSubscriptions />,
        path: "/pricing-billing",
        isActive: currentPath === "pricing-billing",
      },
      {
        name: "Help",
        icon: <IoHelpBuoyOutline />,
        path: "/faq/all",
        isActive: currentPath === "faq",
      },
    ];
  }, [pathname]);

  const toggleMenuView = () => {
    setCollapsed((prevState) => {
      localStorage.setItem("sidebar-collapsed", JSON.stringify(!prevState));
      return !prevState;
    });
  };

  const logoutHandler = () => {
    dispatch(setLogout());
    const user = PoolData.getCurrentUser();
    user?.signOut();
  };

  return (
    <div
      className={`${styles.container} ${isCollapsed ? styles.collapsed : ""}`}
    >
      <ul className={styles.sidebarItems}>
        <li
          className={`${styles.sidebarItem} ${styles.toggleItem}`}
          onClick={toggleMenuView}
        >
          <span className={styles.sidebarIcon}>
            <FiMenu />
          </span>
          <span className={styles.sidebarTitle}>CryptoCrispy</span>
        </li>
        {/*<SidebarItem icon={<FiMenu />} path="/dashboard" name="CryptoCrispy" />*/}
        {itemsData?.map((item, index) => (
          <SidebarItem {...item} key={index} />
        ))}

        <ul className={styles.footer}>
          <li>
            <Link
              to="/profile/info"
              className={`${styles.sidebarItem} ${pathname.split("/")?.[1] === "profile" ? styles.active : ""}`}
            >
              <span className={styles.sidebarIcon}>
                <FaRegCircleUser />
              </span>
              <span className={styles.sidebarTitle}>Profile</span>
            </Link>
          </li>
          <li
            className={styles.sidebarItem}
            onClick={logoutHandler}
            style={{ marginTop: ".2rem" }}
          >
            <span className={styles.sidebarIcon}>
              <IoLogOutOutline />
            </span>
            <span className={styles.sidebarTitle}>Logout</span>
          </li>
        </ul>
      </ul>
    </div>
  );
}

export default Sidebar;
